import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as filterAPI from 'api/Evalution';
import { objectToArray, sortByPriorityIndex } from 'utils/redux';
import { TYPEOF_FIELD_FILTER, smoothMerge, extraFilterSmoothMerge } from 'utils/Sidebar';
import { validateErrorAndCheckArray } from 'utils/validation';
const initialState = {
  status: '',
  data: null,
  features_filter: null,
  EvaluationFilterConfigData: null,
  extra_filter: null,
  LOB: null,
  LOBTeam: null,
  LOBTeamAgent: null,
  rangeDate: null,
  shown: false,
  fields: {},
  fields_config: {
    ext_phone: {
      visiblity: true,
      type: TYPEOF_FIELD_FILTER.AUTO_SELECT
    },
    call_duration: {
      type: TYPEOF_FIELD_FILTER.RANGE,
      visiblity: true
    },
    tenure: {
      type: TYPEOF_FIELD_FILTER.RADIO,
      visiblity: true
    },
    by_shift: {
      type: TYPEOF_FIELD_FILTER.MULTIPLE_SELECT,
      visiblity: true
    },
    call_direction: {
      type: TYPEOF_FIELD_FILTER.MULTIPLE_SELECT,
      visiblity: true
    },
    tagging: {
      type: TYPEOF_FIELD_FILTER.MULTIPLE_SELECT,
      visiblity: true
    },
    skill_set: {
      type: TYPEOF_FIELD_FILTER.MULTIPLE_SELECT,
      visiblity: true
    }
  },
  selected: {
    LOB: [],
    LOBTeam: [],
    LOBTeamAgent: [],
    fields: {},
    rowFilter: {
      LOB: false,
      LOBTeam: false,
      LOBTeamAgent: false
    }
  },
  ui: {
    LOB: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeam: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeamAgent: {
      status: '',
      loading: false
    },
    loading: false
  },

  error: null,
  TeamFeatureData: null
};
const getFilterState = (state) => state.filter;
const getEvaluationConfigData = createAsyncThunk('evaluationfilter/getEvaluationConfigData', async (_, { rejectWithValue }) => {
  try {
    const res = await filterAPI.getEvaluationConfigData();
    const data = res?.data?.data;
    // let fields;
    if (data) {
      let extra_filter = {};
      if (data.advancefilter) {
        for (const key in data.advancefilter.features_data) {
          extra_filter[key] = {
            slug: key,
            ...data.advancefilter.features_data[key]
          };
        }
        extra_filter = sortByPriorityIndex(extra_filter);
      } else {
        extra_filter = null;
      }
      let feature_filter = {};
      if (data.features_filter) {
        for (const key in data.features_filter.features_data) {
          feature_filter[key] = objectToArray(data.features_filter.features_data[key]);
        }
      } else {
        // fields = null;
      }
      return {
        ...data,
        data: {
          extra_filter: extra_filter,
          feature_filter: feature_filter
        }
      };
    }
    return null;
  } catch (error) {
    console.error('EvaluationFilter', error);
    return rejectWithValue(error);
  }
});

const getEvaluationTeamFeatureData = createAsyncThunk(
  'evaluationfilter/getEvaluationTeamFeatureData',
  async (params, { rejectWithValue }) => {
    try {
      const res = await filterAPI.getEvaluationTeamFeatureData(params);
      const data = res?.data?.data;
      // return res.data?.data?.features_filter?.features_data;
      // if (res.data?.data) {
      //   const datas = result.features_filter?.features_data;
      //   console.log('datasggg', datas);
      //   //   return Object.entries(datas).map(([key, value]) => {
      //   //     return {
      //   //       ...value,
      //   //       slug: key
      //   //     };
      //   //   });
      //   // } else {
      //   //   return;
      // }
      if (data) {
        let feature_filter = {};
        if (data.features_filter) {
          for (const key in data.features_filter.features_data) {
            feature_filter[key] = objectToArray(data.features_filter.features_data[key]);
          }
        } else {
          // fields = null;
        }
        return {
          ...data,
          data: {
            feature_filter: feature_filter
          }
        };
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const filterSlice = createSlice({
  name: 'evaluationfilter',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setDefaultLobTeamAgent: (state, action) => {
      const {
        LOB,
        LOBTeam,
        LOBTeamAgent
        // selectedLOB,
        // selectedLOBTeam,
        // selectedLOBTeamAgent,
      } = action.payload;
      state.LOB = LOB;
      state.LOBTeam = LOBTeam;
      state.LOBTeamAgent = LOBTeamAgent;
      // state.selected.LOB = selectedLOB;
      // state.selected.LOBTeam = selectedLOBTeam;
      // state.selected.LOBTeamAgent = selectedLOBTeamAgent;
    },

    setLobTeamDataByLob: (state, { payload }) => {
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLobTeamDataByAllLob: (state, { payload }) => {
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      state.LOBTeamAgent = payload;
    },
    setAllLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      state.LOBTeamAgent = payload;
    },
    changeDateRange: (state, action) => {
      state.rangeDate = action.payload;
    },
    setFieldsData: (state, action) => {
      state.fields = action.payload;
    },

    handleLobAllFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOB;
      state.LOB = state.LOB.map((obj) => ({ ...obj, value: !flag }));
      state.selected.LOB = state.LOB.map((obj) => ({
        ...obj,
        value: !flag
      }));
      console.log(flag, 'vbcncnxv');
      state.selected.rowFilter.LOB = !flag;
    },

    handleAllTeamFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOBTeam;
      state.LOBTeam = state.LOBTeam.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.LOBTeam = state.LOBTeam.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOBTeam = !flag;
    },

    handleAllAgentFilterChange: (state) => {
      const flag = state.selected.rowFilter.LOBTeamAgent;
      state.LOBTeamAgent = state.LOBTeamAgent.map((obj) => ({
        ...obj,
        value: !flag
      }));
      state.selected.rowFilter.LOBTeamAgent = !flag;
    },

    handleLobFilterChange: (state, action) => {
      const findIndex = state.LOB.findIndex((item) => item.id === action.payload.id);
      const flag = action.payload.value;
      if (findIndex !== -1) {
        if (!state.selected.LOB.includes(state.LOB[findIndex])) {
          state.selected.LOB[findIndex] = state.LOB[findIndex];
        }
        if (flag !== undefined) {
          if (!state.selected.LOB[findIndex]) {
            state.selected.LOB[findIndex] = {};
          }
          state.selected.LOB[findIndex].value = flag;
          if (!flag) state.selected.rowFilter.LOB = flag;
          else {
            const filtered = state.LOB.filter((item) => item.value === flag);
            if (state.LOB.length === filtered.length) {
              state.selected.rowFilter.LOB = flag;
            }
          }
        }

        if (!state.selected.rowFilter.LOB) {
          state.selected.rowFilter.LOBTeam = false;
        }
      }
    },

    handleTeamFilterChange: (state, action) => {
      // console.log(action.payload, 'letmecheck');
      state.ui.LOBTeam.flag = true;
      const flag = action.payload.value;
      const findIndex = state.LOBTeam.findIndex((item) => item.id === action.payload.id);
      if (findIndex !== -1) {
        if (!state.selected.LOBTeam.includes(state.LOBTeam[findIndex])) {
          state.selected.LOBTeam[findIndex] = state.LOBTeam[findIndex];
        }

        if (flag !== undefined) {
          if (!state.selected.LOBTeam[findIndex]) {
            state.selected.LOBTeam[findIndex] = {}; // Initialize if not defined
          }

          state.selected.LOBTeam[findIndex].value = flag;

          if (!flag) state.selected.rowFilter.LOBTeam = flag;
          else {
            const filtered = state.LOBTeam.filter((item) => item.value === flag);
            console.log(filtered, 'filtered');
            if (state.LOBTeam.length === filtered.length) {
              state.selected.rowFilter.LOBTeam = flag;
            }
          }
        }
        if (!state.selected.rowFilter.LOBTeam) {
          state.selected.rowFilter.LOBTeamAgent = false;
        }
      }
    },

    handleAgentFilterChange: (state, action) => {
      const findIndex = state.LOBTeamAgent.findIndex((item) => item.id === action.payload.id);
      const flag = action.payload.value;
      if (!state.selected.LOBTeamAgent.includes(state.LOBTeamAgent[findIndex])) {
        state.selected.LOBTeamAgent[findIndex] = state.LOBTeamAgent[findIndex];
      }
      state.selected.LOBTeamAgent[findIndex].value = flag;
      if (!flag) state.selected.rowFilter.LOBTeamAgent = flag;
      else {
        const filtered = state.LOBTeamAgent.filter((item) => item.value === flag);
        if (state.LOBTeamAgent.length === filtered.length) {
          state.selected.rowFilter.LOBTeamAgent = flag;
        }
      }
      // state.LOBTeamAgent[findIndex].value = action.payload.value;
    },

    handleSetExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = action.payload.value;
    },
    handleRemoveExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = null;
    },

    handleSetMultipleExtraFilterData: (state, action) => {
      // console.log('extrafilterAction', action.payload);
      if (state.data.extra_filter[action.payload.filter_type].selected instanceof Array) {
        if (state.data.extra_filter[action.payload.filter_type].selected.includes(action.payload.value)) {
          const prevData = state.data.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
          // state.data.extra_filter[action.payload.filter_type].selected.pop(
          //   action.payload.value
          // );
        } else {
          state.data.extra_filter[action.payload.filter_type].selected.push(action.payload.value);
        }
      } else state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleSetsingleExtraFilterData: (state, action) => {
      state.data.extra_filter[action.payload.filter_type].selected = [action.payload.value];
    },
    handleRemoveMultipleExtraFilterData: (state, action) => {
      const prevData = state.data.extra_filter[action.payload.filter_type].selected;
      var index = prevData.indexOf(action.payload.value);
      if (index !== -1) {
        prevData.splice(index, 1);
      }
      // state.data.extra_filter[action.payload.filter_type].selected.pop(
      //   action.payload.value
      // );
    },
    handleRemoveMultipleExtraFilterDataFromApplied: (state, action) => {
      if (validateErrorAndCheckArray(state.extra_filter[action.payload.filter_type].selected)) {
        if (validateErrorAndCheckArray(action.payload.value)) {
          state.extra_filter[action.payload.filter_type].selected = null;
        } else {
          const prevData = state.extra_filter[action.payload.filter_type].selected;
          var index = prevData.indexOf(action.payload.value);
          if (index !== -1) {
            prevData.splice(index, 1);
          }
        }
      } else {
        state.extra_filter[action.payload.filter_type].selected = null;
      }
      if (state.data.extra_filter) {
        state.data.extra_filter = state.extra_filter;
      }
    },

    handleRemoveMultipleFeatureFilterDataFromApplied: (state = initialState, action) => {
      const { filter_type, value } = action.payload;
      state.shown = false;
      // Find the key in features_filter where the filter_type is present
      const matchingFeatureKey = Object.keys(state.features_filter).find((key) =>
        state.features_filter[key].some((item) => item.slug === filter_type)
      );

      if (matchingFeatureKey) {
        // Update the features_filter by removing the specified value
        const updatedFeaturesFilter = {
          ...state.features_filter,
          [matchingFeatureKey]: state.features_filter[matchingFeatureKey].map((item) =>
            item.slug === filter_type
              ? {
                  ...item,
                  selected: Array.isArray(item.selected) && item.selected.length > 1 ? item.selected.filter((_el) => _el !== value) : null
                }
              : item
          )
        };

        // Use the spread operator to create a new object with updated feature_filter
        const updatedState = {
          ...state,
          features_filter: updatedFeaturesFilter,
          data: {
            ...state.data,
            feature_filter: updatedFeaturesFilter
          }
        };

        return updatedState;
      }

      // No changes if the matching feature is not found
      return state;
    },

    handleSetMultipleFeatureFilterData: (state, action) => {
      const { filter_type, index, value, slug } = action.payload;
      state.shown = false;
      if (slug && state.data.feature_filter && state.data.feature_filter[filter_type]) {
        const foundIndex = state.data.feature_filter[filter_type].findIndex((_el) => _el.slug === slug);
        if (foundIndex !== -1) {
          state.data.feature_filter[filter_type][foundIndex].selected = value;
          // Attribute (fatal / non_fatal) sub-filters only apply when "Not Adhered" is chosen.
          if (value !== 'Not Adhered') {
            state.data.feature_filter[filter_type][foundIndex].fatal_selected = null;
            state.data.feature_filter[filter_type][foundIndex].non_fatal_selected = null;
          }
        }
      } else {
        if (state.data.feature_filter && state.data.feature_filter[filter_type] && state.data.feature_filter[filter_type][index]) {
          state.data.feature_filter[filter_type][index].selected = value;
          if (value !== 'Not Adhered') {
            state.data.feature_filter[filter_type][index].fatal_selected = null;
            state.data.feature_filter[filter_type][index].non_fatal_selected = null;
          }
        }
      }

      // if (state.data.feature_filter[action.payload?.filter_type].selected instanceof Array) {
      //   if (state.data.feature_filter[action.payload?.filter_type].selected.includes(action.payload.value)) {
      //     const prevData = state.data.feature_filter[action.payload?.filter_type].selected;
      //     var index = prevData.indexOf(action.payload.value);
      //     if (index !== -1) {
      //       prevData.splice(index, 1);
      //     }
      //     // state.data.extra_filter[action.payload.filter_type].selected.pop(
      //     //   action.payload.value
      //     // );
      //   } else {
      //     state.data.feature_filter[action.payload.filter_type].selected.push(action.payload.value);
      //   }
      // } else state.data.feature_filter[action.payload.filter_type].selected = [action.payload?.value];
    },
    handleSetMultipleSelectFilterData: (state, action) => {
      const { filter_type, /* index, */ value, slug } = action.payload;
      // state.data.feature_filter[filter_type][index].selected = value;
      if (state.data.feature_filter && state.data.feature_filter[filter_type]) {
        const index = state.data.feature_filter[filter_type].findIndex((_el) => _el.slug === slug);
        if (index !== -1) {
          const selectedItems = state.data.feature_filter[filter_type][index].selected;
          if (selectedItems && !selectedItems.includes(value)) {
            state.data.feature_filter[filter_type][index].selected.push(value);
          } else if (selectedItems && selectedItems.includes(value)) {
            const idx = selectedItems.indexOf(value);
            state.data.feature_filter[filter_type][index].selected.splice(idx, 1);
          } else {
            state.data.feature_filter[filter_type][index].selected = [value];
          }
        }
      }
    },
    handleRemoveMultipleSelectFilterData: (state, action) => {
      const { filter_type, index, value } = action.payload;
      const selectedItems = state.data.feature_filter[filter_type][index].selected;
      if (selectedItems && selectedItems.includes(value)) {
        const idx = selectedItems.indexOf(value);
        state.data.feature_filter[filter_type][index].selected.splice(idx, 1);
      }
      if (selectedItems && !state.data.feature_filter[filter_type][index].selected.length)
        state.data.feature_filter[filter_type][index].selected = null;
    },
    handleRemoveFeatureExtraFilterData: (state, action) => {
      const { filter_type, index } = action.payload;

      state.data.feature_filter[filter_type][index].selected = null;
      state.data.feature_filter[filter_type][index].fatal_selected = null;
      state.data.feature_filter[filter_type][index].non_fatal_selected = null;
    },
    // Toggle a fatal / non_fatal attribute value for a Skills & Core Parameters item (radio "Not Adhered").
    handleSetFeatureAttributeData: (state, action) => {
      const { filter_type, slug, attribute, value } = action.payload; // attribute: 'fatal' | 'non_fatal'
      const key = attribute === 'fatal' ? 'fatal_selected' : 'non_fatal_selected';
      if (state.data.feature_filter && state.data.feature_filter[filter_type]) {
        const idx = state.data.feature_filter[filter_type].findIndex((_el) => _el.slug === slug);
        if (idx !== -1) {
          const current = state.data.feature_filter[filter_type][idx][key];
          if (!Array.isArray(current)) {
            state.data.feature_filter[filter_type][idx][key] = [value];
          } else if (current.includes(value)) {
            current.splice(current.indexOf(value), 1);
            if (current.length === 0) state.data.feature_filter[filter_type][idx][key] = null;
          } else {
            current.push(value);
          }
        }
      }
    },

    // Feature Filter
    // Apply Button
    setFeatureFilter: (state) => {
      return {
        ...state,
        features_filter: state.data.feature_filter,
        shown: false
      };
    },
    // Reset Button
    resetFeatureFilter: (state) => {
      state.features_filter = null;
    },

    // Advanced Filter
    // Apply Button
    setExtraFilter: (state) => {
      state.extra_filter = state.data.extra_filter;
    },
    // Reset Button
    resetExtraFilter: (state) => {
      state.extra_filter = null;
    },
    handleChangeAddtionalFields: (state, action) => {
      const { keyName, values, flag } = action.payload;

      if (!Object.prototype.hasOwnProperty?.call(state.selected.fields, keyName)) {
        state.selected.fields[keyName] = flag;
      } else {
        state.selected.fields[keyName] = flag;
      }

      Object.keys(values)?.map((item, index) => {
        state.fields[keyName][index].selected = flag;
      });
    },
    handleChangeAddtionalSubFields: (state, action) => {
      const { parentKey, flag, index } = action.payload;
      state.fields[parentKey][index].selected = flag;
      if (!flag) state.selected.fields[parentKey] = flag;
      else {
        const original = Object.values(state.fields[parentKey]);
        const filtered = original.filter((item) => item.selected === flag);
        if (original.length === filtered.length) {
          state.selected.fields[parentKey] = flag;
        }
      }
    },

    clearExtraFilter: (state) => {
      if (state.data.extra_filter) {
        Object.keys(state.data.extra_filter).forEach((key) => {
          state.data.extra_filter[key].selected = null;
        });
      }
    },

    clearLobTeamAgent: (state) => {
      const updatedLOB = state.LOB.map((item) => ({
        ...item,
        value: false
      }));
      state.LOB = updatedLOB;
      state.LOBTeam = [];
      state.LOBTeamAgent = [];
      state.selected.LOB = [];
      state.selected.LOBTeam = [];
      state.selected.LOBTeamAgent = [];
      // state.rangeDate = [];
    },

    clearFeatureFilter: (state) => {
      if (state.data.feature_filter) {
        Object.keys(state.data.feature_filter).forEach((key) => {
          state.data.feature_filter[key].forEach((_item) => {
            _item.selected = null;
            _item.fatal_selected = null;
            _item.non_fatal_selected = null;
          });
        });
      }
    },

    setAllfilterFromParent: (state, action) => {
      if (action.payload) {
        // state.data = mergeFilterData(state.data, action.payload.data);
        // state.features_filter = action.payload.features_filter || state.features_filter;
        state.extra_filter = smoothMerge(state.extra_filter, action.payload.extra_filter);
        state.features_filter = smoothMerge(state.features_filter, action.payload.features_filter);
        state.LOB = action.payload.LOB;
        state.LOBTeam = action.payload.LOBTeam;
        state.LOBTeamAgent = action.payload.LOBTeamAgent;
        state.rangeDate = action.payload.rangeDate;
        state.fields = action.payload.fields;
        state.selected = action.payload.selected;
      }
    },
    handleshown: (state, action) => {
      state.shown = action.payload;
    },
    setSelectedDatafromParent: (state, action) => {
      console.log(action.payload, 'jhsgfsfdhg');
      if (action.payload?.parentFilters) {
        state.data.extra_filter = extraFilterSmoothMerge(state.data.extra_filter, action.payload.parentFilters?.extra_filter);
        state.extra_filter = action.payload.parentFilters?.extra_filter;
        state.selected = action.payload.parentFilters?.selected;
        state.LOB = action.payload.parentFilters?.LOB;
        state.LOBTeam = action.payload.parentFilters?.LOBTeam;
        state.rangeDate = action.payload.parentFilters?.rangeDate;
        state.LOBTeamAgent = action.payload.parentFilters?.LOBTeamAgent;
      }
      const filtered = state.LOB.every((item) => item.value === true);
      console.log(filtered, 'xvcb');
      if (filtered) {
        state.selected.rowFilter.LOB = true;
      } else {
        state.selected.rowFilter.LOB = false;
      }
      if (action.payload && state.data.feature_filter) {
        Object.values(state.data.feature_filter).map((item) => {
          item.map((sub_cat) => {
            //calls: completed filter is selected by default and selected for all other design_types except calls_component
            if (sub_cat.slug === 'calls' && sub_cat.value.includes(action.payload?.selectedSlug)) {
              sub_cat.selected = [action.payload?.selectedSlug];
            } else if (sub_cat.slug === 'calls') {
              if (action.payload?.selectedSlug === 'all') sub_cat.selected = sub_cat.value;
              // else sub_cat.selected = [];
              else sub_cat.selected = ['completed'];
            }

            if (action.payload?.isSentiment && sub_cat.slug === action.payload?.selectedSlug) {
              if (action.payload?.convertSlug) {
                sub_cat.selected = [action.payload?.convertSlug];
              } else {
                sub_cat.selected = ['Negative'];
              }
            } else if (action.payload?.isdetailcomponentwithavg && sub_cat.slug === action.payload?.selectedSlug) {
              if (action.payload?.convertSlug) {
                sub_cat.selected = [action.payload?.convertSlug];
              } else {
                sub_cat.selected = ['Not Adhered'];
              }
            } else if (action.payload?.isdetailcomponent && sub_cat.slug === action.payload?.selectedSlug) {
              if (action.payload?.convertSlug) {
                sub_cat.selected = action.payload?.convertSlug;
              } else {
                sub_cat.selected = ['Not Adhered'];
              }
              // if (action.payload?.convertSlug === 'Adhered') {
              //   sub_cat.selected = ['Adhered'];
              // } else if (action.payload?.convertSlug === 'Not Adhered') {
              //   sub_cat.selected = ['Not Adhered'];
              // } else if (action.payload?.convertSlug === 'Not Applicable') {
              //   sub_cat.selected = ['Not Applicable'];
            } else if (action.payload?.bucket_name && sub_cat.slug === action.payload?.selectedSlug) {
              sub_cat.selected = [action.payload?.bucket_name];
            } else if (action.payload?.isKeywordsAndTopics && sub_cat.slug === action.payload?.selectedSlug) {
              sub_cat.selected = [action.payload?.convertSlug];
            } else if (sub_cat.slug === action.payload?.selectedSlug) {
              sub_cat.selected = 'Not Adhered';
            } else if (sub_cat.slug !== 'calls') {
              sub_cat.selected = null;
            }
          });
          // console.log('setSelectedDatafromParent',(modifyData));
        });

        (state.features_filter = state.data.feature_filter), (state.shown = false);
      }
    }
  },

  extraReducers: {
    [getEvaluationConfigData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getEvaluationConfigData.fulfilled]: (state, action) => {
      console.log('getEvaluationConfigData', action.payload);
      state.status = 'idle';
      state.ui.loading = false;
      const { data, ...others } = action.payload;
      state.EvaluationFilterConfigData = others;
      state.LOB = others?.select_lob?.value;
      state.LOBTeam = !state.LOB ? others?.select_team?.value : [];
      state.LOBTeamAgent = !state.LOB && !state.LOBTeam ? others?.select_agent?.value : [];
      state.rangeDate = others?.select_date?.value;
      state.data = data;
      state.extra_filter = data?.extra_filter || {};
    },

    [getEvaluationConfigData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [getEvaluationTeamFeatureData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getEvaluationTeamFeatureData.fulfilled]: (state, action) => {
      const { data } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          ...data
        }
      };
    },

    [getEvaluationTeamFeatureData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  setFieldsData,
  changeDateRange,
  handleLobFilterChange,
  handleLobAllFilterChange,
  handleTeamFilterChange,
  handleAllTeamFilterChange,
  handleAgentFilterChange,
  handleAllAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  setFeatureFilter,
  setExtraFilter,
  handleSetMultipleExtraFilterData,
  handleSetsingleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleRemoveMultipleFeatureFilterDataFromApplied,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  clearFeatureFilter,
  clearExtraFilter,
  setAllfilterFromParent,
  setSelectedDatafromParent,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLobTeamDataByAllLob,
  clearLobTeamAgent,
  handleshown,
  setLOBTeamAgentDataByLobTeam,
  setAllLOBTeamAgentDataByLobTeam,
  handleSetMultipleSelectFilterData,
  handleRemoveMultipleSelectFilterData,
  handleSetFeatureAttributeData
} = filterSlice.actions;

export default filterSlice.reducer;

export {
  getFilterState,
  resetState,
  setFieldsData,
  changeDateRange,
  getEvaluationConfigData,
  handleLobFilterChange,
  handleLobAllFilterChange,
  handleTeamFilterChange,
  handleAllTeamFilterChange,
  handleAgentFilterChange,
  handleAllAgentFilterChange,
  handleSetExtraFilterData,
  handleRemoveExtraFilterData,
  handleSetMultipleExtraFilterData,
  handleSetsingleExtraFilterData,
  handleRemoveMultipleExtraFilterData,
  handleSetMultipleFeatureFilterData,
  handleRemoveFeatureExtraFilterData,
  handleRemoveMultipleExtraFilterDataFromApplied,
  handleRemoveMultipleFeatureFilterDataFromApplied,
  handleChangeAddtionalFields,
  handleChangeAddtionalSubFields,
  setFeatureFilter,
  setExtraFilter,
  clearFeatureFilter,
  clearExtraFilter,
  setAllfilterFromParent,
  setSelectedDatafromParent,
  setDefaultLobTeamAgent,
  setLobTeamDataByLob,
  setLobTeamDataByAllLob,
  clearLobTeamAgent,
  handleshown,
  setLOBTeamAgentDataByLobTeam,
  setAllLOBTeamAgentDataByLobTeam,
  handleSetMultipleSelectFilterData,
  handleRemoveMultipleSelectFilterData,
  handleSetFeatureAttributeData,
  getEvaluationTeamFeatureData
};
